import { atom } from '@reatom/framework'

import { ExploreFeedType } from '@root/features/explore/model/explore-feed-type'

export const exploreTabAtom = atom<ExploreFeedType>(
  ExploreFeedType.Trending,
  'exploreTabAtom',
)
